import { IGameIdentity } from "motw_core/Entity/IGameIdentity";
import * as React from "react";
import { DeepWorkKipsTodayState } from "source/app/presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsToday";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IGameIdentityDTO } from "../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import { StyleClass } from "../../../../Shared/Styles/CSS";

export function IdentityScore({ identity }: { identity: IGameIdentityDTO }) {
    const kipsNeededForMaximum = GetKipsNeededForMaximumIdentityScore(identity);

    if (kipsNeededForMaximum === 0) {
        return null;
    }

    return (
        <div
            className={StyleClass(`identityScoreContainer`, {
                margin: `10px`,
            })}
        >
            At {identity.kipsPercentAchieved}%, needing{" "}
            <span
                {...Style(`bold`, {
                    fontWeight: `bold`,
                })}
            >
                {kipsNeededForMaximum}
            </span>
            ₭ to get to {identity.maxscore}%
        </div>
    );
}

export function GetKipsNeededForMaximumIdentityScore(
    identity: IGameIdentityDTO
) {
    if (identity.kipsPercentAchieved >= identity.maxscore) {
        return 0;
    }

    const deepWorkKipsToday = State.ReadClass<DeepWorkKipsTodayState>(
        ESharedComponent.DeepWorkKipsToday
    );

    if (!deepWorkKipsToday) {
        return 0;
    }

    const kipsNeededForMaximum = Math.ceil(
        ((identity.maxscore - identity.kipsPercentAchieved) / 100) *
            deepWorkKipsToday.state.kipsDTO.kipsToday
    );

    return kipsNeededForMaximum;
}
